import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

export class OMSSocialMediaBox extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
    style: PropTypes.object,
    onChange: PropTypes.func,
    boxType: PropTypes.number
  };

  static defaultProps = {
    id: "",
    name: "",
    value: null,
    onChange: null,
    style: null,
    boxType: 0 // 0 -> Contact,  1 -> User
  };

  state = {
    Contact: {
      facebook: this.props.value.facebook,
      twitter: this.props.value.twitter,
      linkedin: this.props.value.linkedin,
      instagram: this.props.value.instagram,
      privyseal: this.props.value.privyseal,
      tiktok: this.props.value.tiktok,
      yt: this.props.value.yt
    },
  };

  handleLinkClick = (e) => {
    var value = window.$("#socailModelInput").val();
    if (value != "") {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if (!regex.test(value)) {
        var name = window.$("#socailModelInput").data("name");
        var url = "";
        if (name == "facebook") {
          url = "https://www.facebook.com/";
        } else if (name == "twitter") {
          url = "https://twitter.com/";
        } else if (name == "linkedin") {
          url = "https://www.linkedin.com/in/";
        } else if (name == "instagram") {
          url = "https://www.instagram.com/";
        } else if (name == "privyseal") {
          url = "https://www.privyseal.com/";
        }
        else if (name == "tiktok") {
          url = "https://www.tiktok.com/";
        }
        else if (name == "yt") {
          url = "https://www.youtube.com/";
        }
        window.open(url + value);
      } else {
        window.open(value);
      }
    }
  };

  handleSaveClick = (e) => {
    window.$("#socialModel").modal("hide");
    var value = window.$("#socailModelInput").val();
    var name = window.$("#socailModelInput").data("name");
    var Contact = this.state.Contact;
    Contact[name] = value;
    this.setState({
      Contact: Contact,
    });
    if (this.props.onChange) this.props.onChange(name, value);
  };

  handleClick = (name) => {
    var value = "";
    var label = "";
    if (name == "facebook") {
      value = this.state.Contact.facebook;
      label = "Facebook handle";
    } else if (name == "twitter") {
      value = this.state.Contact.twitter;
      label = "Twitter handle";
    } else if (name == "linkedin") {
      value = this.state.Contact.linkedin;
      label = "Linkedin handle";
    } else if (name == "instagram") {
      value = this.state.Contact.instagram;
      label = "Instagram handle";
    } else if (name == "privyseal") {
      value = this.state.Contact.privyseal;
      label = "Privyseal handle";
    }
    else if (name == "tiktok") {
      value = this.state.Contact.tiktok;
      label = "Tiktok handle";
    }
    else if (name == "yt") {
      value = this.state.Contact.yt;
      label = "Youtube handle";
    }

    window.$("#socailModelInput").val(value);
    window.$("#socailModelInput").data("name", name);
    window.$("#socailModelLabel").text(label);
    window.$("#socialModel").modal("show");
  };

  renderIcon = (platform, iconClass) => (
    <span id={platform} title={platform == 'yt' ? 'youtube' : platform} name={platform} onClick={() => this.handleClick(platform)}>
      <i
        className={`${iconClass} oms-social-handle${this.state.Contact[platform] ? " oms-social-handle-active" : ""
          }`}
      ></i>
    </span>
  );

  render() {
    return (
      <div className="tw-flex">
        {this.renderIcon("facebook", "fa fa-facebook-square")}
        {this.renderIcon("twitter", "fa fa-twitter-square")}
        {this.renderIcon("linkedin", "fa fa-linkedin-square")}
        {this.renderIcon("instagram", "fa fa-instagram")}
        {this.props.boxType == 1 &&
          <>
            {this.renderIcon("privyseal", "fa fa-certificate")}
            {this.renderIcon("yt", "fa fa-youtube-play")}
            <span
              id="tiktok"
              title="tiktok"
              name="tiktok"
              onClick={() => this.handleClick("tiktok")}
            >
              <svg width="30" height="30" stroke-width="2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`oms-social-handle${this.state.Contact.tiktok ? ' oms-social-handle-active' : ''}`}>
                <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 12C8.34315 12 7 13.3431 7 15C7 16.6569 8.34315 18 10 18C11.6569 18 13 16.6569 13 15V6C13.3333 7 14.6 9 17 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"

                />
              </svg>
            </span>
          </>
        }
        <div id="socialModel" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal">
                  ×
                </button>
                <h4 className="modal-title">
                  <label id="socailModelLabel"></label>
                </h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    id="socailModelInput"
                    name="socailModelInput"
                  />
                  <button
                    type="button"
                    className="btn btn-default"
                    style={{ marginLeft: 10 }}
                    onClick={this.handleLinkClick}
                  >
                    <i className="fa fa-link"></i>
                  </button>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={this.handleSaveClick}
                >
                  <i className="fa fa-check"></i>Save
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  <i className="fa fa-times"></i>Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class OMSContactBoxView extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
    style: PropTypes.object,
  };

  static defaultProps = {
    id: "",
    name: "",
    value: null,
    style: null,
  };

  state = {
    Contact: {
      facebook: this.props.value.facebook,
      twitter: this.props.value.twitter,
      linkedin: this.props.value.linkedin,
      instagram: this.props.value.instagram,
    },
  };

  OpenSocialLink = (name, value) => {
    if (value != "") {
      var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
      if (!regex.test(value)) {
        var url = "";
        if (name == "facebook") {
          url = "https://www.facebook.com/";
        } else if (name == "twitter") {
          url = "https://twitter.com/";
        } else if (name == "linkedin") {
          url = "https://www.linkedin.com/in/";
        } else if (name == "instagram") {
          url = "https://www.instagram.com/";
        }
        window.open(url + value);
      } else {
        window.open(value);
      }
    }
  };

  OpenEmailClick = (email) => {
    window.open("mailto:" + email);
  };

  OpenCallClick = (phone) => {
    window.open("tel:" + phone);
  };
  OpenWhatsApp = (phone) => {
    const url = `https://wa.me/${phone}`;
    window.open(url, "_blank", "noreferrer");
  };

  render() {
    return (
      <div className="d-flex">
        {this.props.value.phone == "" ? null : (
          <span
            id="phone"
            name="phone"
            data-toggle="tooltip"
            data-placement="bottom"
            title={
              this.props.value.phone_dialing_code + " " + this.props.value.phone
            }
            onClick={() =>
              this.OpenCallClick(
                this.props.value.phone_dialing_code + this.props.value.phone
              )
            }
          >
            <i
              className={
                "fa fa-phone-square oms-social-handle" +
                (this.props.value.phone == ""
                  ? ""
                  : " oms-social-handle-active")
              }
            ></i>
          </span>
        )}
        {this.props.email == "" ? null : (
          <span
            id="email"
            name="email"
            data-toggle="tooltip"
            data-placement="bottom"
            title={this.props.email}
            onClick={() => this.OpenEmailClick(this.props.email)}
          >
            <i
              className={
                "fa fa-envelope-square oms-social-handle" +
                (this.props.email == "" ? "" : " oms-social-handle-active")
              }
            ></i>
          </span>
        )}
        {this.props.value.facebook == "" ? null : (
          <span
            id="facebook"
            name="facebook"
            onClick={() =>
              this.OpenSocialLink("facebook", this.props.value.facebook)
            }
          >
            <i
              className={
                "fa fa-facebook-square oms-social-handle" +
                (this.props.value.facebook == ""
                  ? ""
                  : " oms-social-handle-active")
              }
            ></i>
          </span>
        )}
        {this.props.value.twitter == "" ? null : (
          <span
            id="twitter"
            name="twitter"
            onClick={() =>
              this.OpenSocialLink("twitter", this.props.value.twitter)
            }
          >
            <i
              className={
                "fa fa-twitter-square oms-social-handle" +
                (this.props.value.twitter == ""
                  ? ""
                  : " oms-social-handle-active")
              }
            ></i>
          </span>
        )}
        {this.props.value.linkedin == "" ? null : (
          <span
            id="linkedin"
            name="linkedin"
            onClick={() =>
              this.OpenSocialLink("linkedin", this.props.value.linkedin)
            }
          >
            <i
              className={
                "fa fa-linkedin-square oms-social-handle" +
                (this.props.value.linkedin == ""
                  ? ""
                  : " oms-social-handle-active")
              }
            ></i>
          </span>
        )}
        {this.props.value.instagram == "" ? null : (
          <span
            id="instagram"
            name="instagram"
            onClick={() =>
              this.OpenSocialLink("instagram", this.props.value.instagram)
            }
          >
            <i
              className={
                "fa fa-instagram oms-social-handle" +
                (this.props.value.instagram == ""
                  ? ""
                  : " oms-social-handle-active")
              }
            ></i>
          </span>
        )}
        {this.props.value.phone == "" ? null : (
          <span
            id="whatsapp"
            className="d-flex align-items-center"
            name="whatsapp"
            data-toggle="tooltip"
            data-placement="bottom"
            title={
              this.props.value.phone_dialing_code + " " + this.props.value.phone
            }
            style={{ cursor: "pointer" }}
            onClick={() =>
              this.OpenWhatsApp(
                this.props.value.phone_dialing_code + this.props.value.phone
              )
            }
          >
            <i
              className="fa fa-whatsapp"
              style={{
                fontSize: "30px",
                color: "#92ab1c"
              }}
            ></i>
            <strong style={{ margin: "0px", paddingLeft: "5px", color: "#92ab1c" }}>
              Chat on WhatsApp
            </strong>
          </span>
        )}
      </div>
    );
  }
}
